var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import { FormattedMessage, injectIntl } from 'react-intl';
import Page from '../Page';
import { ApplicationContext } from '../../../ApplicationContext';
import DevicesRow from "./DeviceRow";
import ListOrganisationDevicesCommand from "../../../commands/devices/ListOrganisationDevicesCommand";
/**
 *
 */
var Devices = /** @class */ (function (_super) {
    __extends(Devices, _super);
    /**
     *
     */
    function Devices(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {};
        _this.onSortClick = _this.onSortClick.bind(_this);
        _this.onSearchChange = _this.onSearchChange.bind(_this);
        return _this;
    }
    /**
     *
     */
    Devices.prototype.componentDidMount = function () {
        this.initialize();
    };
    /**
     *
     */
    Devices.prototype.initialize = function () {
        var _a = this.context, deviceCollection = _a.deviceCollection, session = _a.session;
        var command = new ListOrganisationDevicesCommand();
        command.execute(deviceCollection);
    };
    /**
     *
     * @returns {*}
     */
    Devices.prototype.render = function () {
        var intl = this.props.intl;
        var _a = this.context, session = _a.session, deviceCollection = _a.deviceCollection;
        if (!this.context.session.isLoggedIn) {
            return null;
        }
        return (React.createElement(Page, { pageName: "devices" },
            React.createElement("div", { className: "h-100 pb-4" },
                React.createElement("div", { className: "card mh-100", style: { width: "95%", borderRadius: "0px 20px 20px 0px" } },
                    React.createElement("div", { className: "card-header flex-grow-0 pb-0" },
                        React.createElement("div", { className: "d-flex justify-content-between mb-4 pr-3 flex-wrap" },
                            React.createElement("h1", { className: 'header-title align-self-center order-0 mr-3' },
                                React.createElement(FormattedMessage, { id: "page.devices.title" })))),
                    React.createElement("div", { className: "card-body pt-0 mr-4 pr-0 overflow-auto" },
                        React.createElement("div", { className: "table-container w-100 h-100 flex-fill" },
                            React.createElement("div", { className: "w-100", style: {
                                    display: "grid",
                                    gridTemplateColumns: "2fr 1fr 1fr 1fr 3fr 1fr",
                                    rowGap: "1.3rem",
                                    minWidth: "fit-content"
                                } },
                                React.createElement("div", { className: 'w-100 position-sticky text-nowrap text-uppercase bg-secondary px-3 pb-2 table-header', style: { display: "contents", top: 0, zIndex: 1 } },
                                    React.createElement("div", { onClick: this.onSortClick, "data-sortBy": "name" },
                                        React.createElement(FormattedMessage, { id: "page.devices.table.column.name" })),
                                    React.createElement("div", { onClick: this.onSortClick, "data-sortBy": "deviceId" },
                                        React.createElement(FormattedMessage, { id: "page.devices.table.column.deviceid" })),
                                    React.createElement("div", { onClick: this.onSortClick, "data-sortBy": "model" },
                                        React.createElement(FormattedMessage, { id: "page.devices.table.column.model" })),
                                    React.createElement("div", { onClick: this.onSortClick, "data-sortBy": "battery" },
                                        React.createElement(FormattedMessage, { id: "page.devices.table.column.battery" })),
                                    React.createElement("div", { onClick: this.onSortClick, "data-sortBy": "location" },
                                        React.createElement(FormattedMessage, { id: "page.devices.table.column.location" })),
                                    React.createElement("div", null)),
                                deviceCollection.filteredAndSorted.map(function (device) {
                                    return React.createElement(DevicesRow, { key: 'di-' + device.link_device_id_serial, device: device });
                                }))))))));
    };
    /**
     *
     */
    Devices.prototype.onSortClick = function (event) {
        var deviceCollection = this.context.deviceCollection;
        var sort = deviceCollection.sort;
        var fieldName = event.target.dataset.sortby;
        var direction = sort.fieldName === fieldName ? sort.direction * -1 : 1;
        deviceCollection.sort.update({ fieldName: event.target.dataset.sortby, direction: direction });
        deviceCollection.updateSortCache();
    };
    /**
     *
     * @param value
     */
    Devices.prototype.onSearchChange = function (value) {
        var deviceCollection = this.context.deviceCollection;
        deviceCollection.searchStringFilter.value = value.toLowerCase();
        deviceCollection.update();
    };
    Devices = __decorate([
        observer
    ], Devices);
    return Devices;
}(React.Component));
Devices.contextType = ApplicationContext;
export default injectIntl(Devices);
